"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.create");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.set-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _native = _interopRequireDefault(require("@emotion/native"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactNative = require("react-native");

var _colorPicker = require("../components/color-picker");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Touchable =
/*#__PURE__*/
_native["default"].TouchableOpacity(function (_ref) {
  var theme = _ref.theme,
      color = _ref.color;
  return {
    borderColor: theme.borderColor || '#e6e6e6',
    width: 30,
    height: 20,
    borderRadius: 2,
    borderWidth: 1,
    margin: 10,
    backgroundColor: color
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

var ColorType =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ColorType, _React$Component);

  function ColorType(props) {
    var _this;

    _classCallCheck(this, ColorType);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ColorType).call(this, props));

    _this.openColorPicker = function () {
      _this.setState({
        displayColorPicker: true
      });
    };

    _this.closeColorPicker = function () {
      _this.setState({
        displayColorPicker: false
      });
    };

    _this.onChangeColor = function (color) {
      var onChange = _this.props.onChange;
      onChange((0, _colorPicker.fromHsv)(color));
    };

    _this.state = {
      displayColorPicker: false
    };
    return _this;
  }

  _createClass(ColorType, [{
    key: "render",
    value: function render() {
      var knob = this.props.knob;
      var displayColorPicker = this.state.displayColorPicker;
      return _react["default"].createElement(_reactNative.View, null, _react["default"].createElement(Touchable, {
        color: knob.value,
        onPress: this.openColorPicker
      }), _react["default"].createElement(_reactNative.Modal, {
        supportedOrientations: ['portrait', 'landscape'],
        transparent: true,
        visible: displayColorPicker,
        onRequestClose: this.closeColorPicker
      }, _react["default"].createElement(_reactNative.TouchableWithoutFeedback, {
        onPress: this.closeColorPicker
      }, _react["default"].createElement(_reactNative.View, {
        style: {
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center'
        }
      }, _react["default"].createElement(_reactNative.TouchableWithoutFeedback, null, _react["default"].createElement(_reactNative.View, {
        style: {
          backgroundColor: 'white',
          borderWidth: 1,
          borderColor: 'rgb(247, 244, 244)',
          width: 250,
          height: 250,
          padding: 10
        }
      }, _react["default"].createElement(_reactNative.TouchableOpacity, {
        onPress: this.closeColorPicker,
        style: {
          alignSelf: 'flex-end',
          padding: 5
        }
      }, _react["default"].createElement(_reactNative.Text, {
        style: {
          fontSize: 18,
          fontWeight: 'bold'
        }
      }, "X")), _react["default"].createElement(_colorPicker.ColorPicker, {
        onColorSelected: this.onChangeColor,
        defaultColor: knob.value,
        style: {
          flex: 1
        }
      })))))));
    }
  }]);

  return ColorType;
}(_react["default"].Component);

ColorType.propTypes = {
  knob: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    value: _propTypes["default"].string
  }),
  onChange: _propTypes["default"].func
};
ColorType.defaultProps = {
  knob: {},
  onChange: function onChange(value) {
    return value;
  }
};

ColorType.serialize = function (value) {
  return value;
};

ColorType.deserialize = function (value) {
  return value;
};

var _default = ColorType;
exports["default"] = _default;